export const version = { "git_hash": "7abc4ce4ba6e279dc7d49a097c361895b3bf7d61" };